import React, { useState, useRef } from 'react';
import Button from '@mui/material/Button';
import { NotificationsPausedOutlined, CachedOutlined } from '@mui/icons-material';
import dayjs from 'dayjs';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { usePatientMutation } from "~/api/patient/usePatientMutation";
import { Box } from "@mui/material";
export const CGMReviewConsent = ({ patient, onUpdatePatient }) => {
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [openWaitingCalendar, setOpenWaitingCalendar] = useState(false);
    const iconRef = useRef(null);
    const { mutateAsync } = usePatientMutation();
    const removeWaitingStatus = async () => {
        console.log('removing waiting status');
        const patientId = patient.id;
        await mutateAsync({ patientId, waitingUntil: 'null' });
        onUpdatePatient({ ...patient, waitingUntil: null });
    };
    const updateWaitingDate = async (newWaitingDate) => {
        console.log('updating waiting status');
        console.log(newWaitingDate);
        const patientId = patient.id;
        await mutateAsync({ patientId, waitingUntil: newWaitingDate.format('YYYY-M-D').toString() });
        onUpdatePatient({ ...patient, waitingUntil: new Date(newWaitingDate.format('YYYY-M-D')) });
    };
    let button;
    let actionButton;
    if (patient.billingCgmEligible === 'Completed') {
        button = React.createElement(Button, { style: { padding: '4px 10px', borderRadius: 6, fontWeight: '700', fontSize: 'x-small', cursor: 'auto', backgroundColor: '#4CAF501A', color: '#4CAF50', fontFamily: 'Barlow' }, variant: "contained", size: "small", disableElevation: true, disableRipple: true, sx: { '&:hover': { backgroundColor: 'unset' } } }, "COMPLETE");
    }
    if (patient.billingCgmEligible === 'Need Data') {
        button = React.createElement(Button, { style: { padding: '4px 10px', borderRadius: 6, fontWeight: '700', fontSize: 'x-small', cursor: 'auto', backgroundColor: '#EF53501A', color: '#EF5350', fontFamily: 'Barlow' }, variant: "contained", size: "small", disableElevation: true, disableRipple: true, sx: { '&:hover': { backgroundColor: 'unset' } } }, "NEED DATA");
    }
    if (patient.billingCgmEligible === 'No Consent') {
        button = React.createElement(Button, { style: { padding: '4px 10px', borderRadius: 6, fontWeight: '700', fontSize: 'x-small', cursor: 'auto', backgroundColor: '#9E9E9E1A', color: '#9E9E9E', fontFamily: 'Barlow' }, variant: "contained", size: "small", disableElevation: true, disableRipple: true, sx: { '&:hover': { backgroundColor: 'unset' } } }, "N/A");
    }
    if (!patient.cgmConsent) {
        button = React.createElement(Button, { style: { padding: '4px 10px', borderRadius: 6, fontWeight: '700', fontSize: 'x-small', cursor: 'auto', fontFamily: 'Barlow', backgroundColor: '#9E9E9E1A', color: '#9E9E9E' }, variant: "contained", size: "small", disableElevation: true, disableRipple: true, sx: { '&:hover': { backgroundColor: 'unset' } } }, "N/A");
    }
    if (patient.billingCgmEligible === 'Ready' && !patient.waitingUntil) {
        button = React.createElement(Button, { style: { padding: '4px 10px', cursor: 'auto', borderRadius: 6, fontWeight: '700', fontSize: 'x-small', backgroundColor: '#42A5F51A', color: '#42A5F5' }, variant: "contained", size: "small", disableElevation: true, disableRipple: true, sx: { '&:hover': { backgroundColor: 'unset' } } }, "READY");
        actionButton = React.createElement(NotificationsPausedOutlined, { ref: iconRef, onClick: () => setOpenWaitingCalendar(true), style: { color: '#2C78EB', cursor: 'pointer' } });
    }
    if (patient.waitingUntil) {
        const today = dayjs().startOf('day');
        const target = dayjs(patient.waitingUntil).startOf('day');
        const diff = target.diff(today, 'day');
        button = React.createElement(Button, { style: { padding: '4px 10px', cursor: 'auto', borderRadius: 6, fontWeight: '700', fontSize: 'x-small', backgroundColor: '#34A5C51A', color: '#34A5C5' }, variant: "contained", size: "small", disableElevation: true, disableRipple: true, sx: { '&:hover': { backgroundColor: 'unset' } } },
            "Waiting (",
            diff,
            ")");
        actionButton = React.createElement(CachedOutlined, { onClick: removeWaitingStatus, style: { color: '#34A5C5', cursor: 'pointer' } });
    }
    return (React.createElement("div", { className: "text-center", style: { marginLeft: 'auto' } },
        button,
        " ",
        actionButton,
        React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
            React.createElement(DatePicker, { open: openWaitingCalendar, onClose: () => setOpenWaitingCalendar(false), value: selectedDate, minDate: dayjs(), onChange: (value) => {
                    updateWaitingDate(dayjs(value));
                    setSelectedDate(value);
                }, slots: { textField: () => React.createElement(React.Fragment, null),
                    toolbar: () => (React.createElement(Box, { sx: { p: 2, display: 'flex', alignItems: 'center', gap: 1 } },
                        React.createElement(NotificationsPausedOutlined, { style: { color: '#2C78EB' } }),
                        React.createElement("div", { style: { fontWeight: 'bold', fontSize: 'medium', color: 'black', fontFamily: 'Barlow' } }, "Snooze Until:")))
                }, slotProps: {
                    textField: {
                        inputProps: { readOnly: true },
                        disabled: true,
                        sx: { display: 'none' },
                    },
                    popper: {
                        anchorEl: iconRef.current,
                        disablePortal: true,
                        sx: {
                            '& .MuiPickersLayout-root': {
                                display: 'flex !important',
                                flexDirection: 'column',
                            },
                        },
                    }
                } }))));
};
